// @ts-nocheck
// bunzl changed import location
import { isUnit } from "@store/Framework/Common/Utilities/unitHelper";

// Valid units source: https://www.w3schools.com/cssref/css_units.php
export const defaultValidCssUnits: string[] = [
    "px",
    "%",
    "em",
    "rem",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "pt",
    "cm",
    "mm",
    "in",
    "pc",
    "ex",
    "ch",
];

const isValidCssUnit = (
    value: string | undefined | null,
    validCssUnits: string[] = defaultValidCssUnits,
    isOptional?: boolean,
) => {
    if (!value) {
        return false;
    }

    return value === "0" || isUnit(value, validCssUnits, isOptional);
};

export default isValidCssUnit;
